/* global google, $ */
'use strict'

$.fn.extend({
  fwAddressPicker: function (t) {
    var geocoder
    var that = this
    if (!(typeof google === 'object' && typeof google.maps === 'object')) {
      $.getScript('https://maps.googleapis.com/maps/api/js?language=no&key=' + t.mapApiKey + '&libraries=places', function () {
        initElements()
        // geocodeAddress('Stenklevveien 6, 4846 Arendal, NO', mapObj)
      })
    } else {
      initElements()
    }

    function initElements () {
      $.each(that, function (p, v) {
        var mapObj = {
          map: undefined,
          marker: false,
          htmlLat: undefined,
          htmlLng: undefined,
          getPosition: function () {
            if (this.htmlLat.value && this.htmlLng.value) {
              return { lat: Number.parseFloat(this.htmlLat.value), lng: Number.parseFloat(this.htmlLng.value) }
            } else {
              return undefined
            }
          },
          setPosition: function (latlng) {
            this.htmlLat.value = latlng.lat()
            this.htmlLng.value = latlng.lng()
          },
          updateField: function (fieldName, data) {
            document.getElementById(fieldName).value = data
          },
          getFieldValue: function (fieldName) {
            return document.getElementById(fieldName).value
          },
          fieldCounty: v.dataset.fieldCounty,
          fieldMunicipality: v.dataset.fieldMunicipality,
          fieldCity: v.dataset.fieldCity,
          fieldPostalCode: v.dataset.fieldPostalCode,
          fieldAddress1: v.dataset.fieldAddress1,
          $feedbackElm: $('#' + v.dataset.idFeedback)
        }

        mapObj.htmlLat = document.getElementById(v.dataset.fieldLat)
        mapObj.htmlLng = document.getElementById(v.dataset.fieldLng)

        initGoogleMap(v, mapObj)
      })
    }

    function initGoogleMap (elem, mapObj) {
      if (!geocoder) {
        geocoder = new google.maps.Geocoder()
      }

      mapObj.map = new google.maps.Map(elem, {
        center: new google.maps.LatLng(mapObj.getPosition() || t.defaultCenter), // Default initial location
        zoom: t.startZoom
      })

      // Initial marker position (saved or default)
      if (mapObj.getPosition()) {
        updateMarkerPosition(mapObj)
      }
      var $address1 = $('#' + mapObj.fieldAddress1)
      var $postalCode = $('#' + mapObj.fieldPostalCode)

      $address1.on('change', function () {
        checkGeoLookup()
      })

      $postalCode.on('change', function () {
        checkGeoLookup()
      })

      function checkGeoLookup () {
        if ($address1.val() && $postalCode.val()) {
          geocodeAddress($address1.val() + ', ' + $postalCode.val(), mapObj)
        }
      }

      google.maps.event.addListener(mapObj.map, 'click', function (event) {
        mapObj.setPosition(event.latLng)
        if (!mapObj.getFieldValue(mapObj.fieldCounty) || !mapObj.getFieldValue(mapObj.fieldMunicipality)) {
          geocodePosition(mapObj.getPosition(), mapObj)
        } else {
          updateMarkerPosition(mapObj)
        }
      })

      return mapObj
    }

    function updateMarkerPosition (mapObj) {
      if (mapObj.marker === false) {
        mapObj.marker = new google.maps.Marker({
          position: mapObj.getPosition(),
          map: mapObj.map,
          draggable: true
        })

        google.maps.event.addListener(mapObj.marker, 'dragend', function (event) {
          // Get the Current position, where the pointer was dropped
          mapObj.setPosition(mapObj.marker.getPosition())

          updateMarkerPosition(mapObj)
        })
      } else {
        mapObj.marker.setPosition(mapObj.getPosition())
      }
      return mapObj
    }

    function geocodeAddress (address, mapObj) {
      clearAlert(mapObj.$feedbackElm)

      geocoder.geocode({
        address: address,
        componentRestrictions: {
          country: 'NO'
        }
      }, function (results, status) {
        if (status === 'OK') {
          updateMapWithGeoCodeResult(mapObj, results[0])
        } else {
          setAlert(mapObj.$feedbackElm, 'Vi kan ikke finne adressen du har oppgitt. Sjekk at den stemmer, eller trykk i kartet for &aring; sett posisjon manuelt.')
        }
      })
    }

    function geocodePosition (location, mapObj) {
      clearAlert(mapObj.$feedbackElm)

      geocoder.geocode({
        location: location
      }, function (results, status) {
        if (status === 'OK') {
          updateMapWithGeoCodeResult(mapObj, results[0])
        } else {
          setAlert(mapObj.$feedbackElm, 'Vi fant ingen adresse informasjon for punktet du har valgt')
        }
      })
    }

    function updateMapWithGeoCodeResult (mapObj, result) {
      mapObj.setPosition(result.geometry.location)
      var address = convertAddress(result)
      console.log(address)
      mapObj.updateField(mapObj.fieldCounty, address.administrative_area_level_1)
      mapObj.updateField(mapObj.fieldMunicipality, address.administrative_area_level_2.toString().toUpperCase())
      mapObj.updateField(mapObj.fieldCity, address.postal_town.toString().toUpperCase())

      if (!mapObj.getFieldValue(mapObj.fieldPostalCode)) {
        mapObj.updateField(mapObj.fieldPostalCode, address.postal_code)
      }

      if (!mapObj.getFieldValue(mapObj.fieldAddress1)) {
        mapObj.updateField(mapObj.fieldAddress1, address.route + ' ' + address.street_number)
      }
      // Update map
      mapObj.map.setCenter(result.geometry.location)
      mapObj.map.panTo(result.geometry.location)
      mapObj.map.setZoom(17)

      // Place a marker in the coordinates
      updateMarkerPosition(mapObj)
    }

    function setAlert ($elm, text) {
      $elm.attr('role', 'alert')
      $elm.addClass('alert alert-danger mb-2')
      $elm.html(text)
    }

    function clearAlert ($elm) {
      $elm.html('')
      $elm.removeClass()
      $elm.attr('role', '')
    }

    function convertAddress (result) {
      var data = []
      data.country = ''
      data.administrative_area_level_1 = ''
      data.administrative_area_level_2 = ''
      data.postal_code = ''
      data.postal_town = ''
      data.route = ''
      data.street_number = ''
      data.formatted_address = result.formatted_address

      $(result.address_components).each(function (i, address) {
        $(address.types).each(function (j, type) {
          if (type === 'country') {
            data[type] = address.short_name
          } else {
            data[type] = address.long_name
          }
        })
      })
      return data
    }
  }
})
